import {createSelectionSlice} from 'entities/monitor';

const server = createSelectionSlice('server', ({serverReducer}) => serverReducer);

export default server.reducer;
export const {toggleOne, selectAllOnPage, clearAll} = server.actions;

export const serverSelectedIdsSelector = server.selectedIdsSelector;
export const isSelectedAllSelector = server.isSelectedAllSelector;
